import { api } from './api';

export const getConfigPageService = ({ slug, ...params }, cancelToken) => {
  return api.get(
    `/activities/templates/${slug}`,
    {
      cancelToken,
      params,
    },
  );
}
